import styles from "./WWAccordion.module.css"

import { randomUUID } from "../../axios_with_token";

export default function WWAccordion({itemDefs, id:idIn}){
    const id=idIn||`accordion-${randomUUID()}`;

    return <div className="accordion accordion-flush" id={id}>
        {itemDefs.map((itemDef, itemIdx)=>{
            const Content = itemDef.Content || (({})=><div>no content</div>);
            const Caption = itemDef.CaptionComp;
            return <div 
                key={`#${id}-${itemIdx}`}
                className="accordion-item"
            >
                <h2 className="accordion-header" id={`${id}-${itemIdx}-heading`}>
                    <button className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${id}-${itemIdx}`}
                        aria-expanded="false"
                        aria-controls={`${id}-${itemIdx}`}
                    >
                        {itemDef.CaptionComp?<Caption></Caption>:itemDef.caption}
                    </button>
                </h2>
                <div id={`${id}-${itemIdx}`}
                    className="accordion-collapse collapse"
                    aria-labelledby={`${id}-${itemIdx}-heading`}
                    data-bs-parent={`#${id}`}
                >
                    <div className="accordion-body">
                        <Content></Content>
                    </div>
                </div>
            </div>;
        })}
    </div>;
}
